import React from "react"

class TopTitle extends React.Component {
  render() {
    return (
      <div className="top-title">
        <h1 className="title is-2 has-text-white text-shadow">
          おいしいテイクアウト料理を
          <br />
          スマートに受け取り。
        </h1>
      </div>
    )
  }
}

export default TopTitle
